<template>
  <div class="app-body">
    <Header></Header>
    <main class="container">
      <div class="col-sm-12 col-md-6 offset-md-3">
        <h1>Contacts</h1>
        <p>For support issues, please use our
          <a href="https://help.ganttproject.biz/c/ganttproject-cloud-support" target="_blank">Support portal</a>
        </p>
        <p>Please use the email address
          <a href="mailto:contact@ganttproject.cloud">contact@ganttproject.cloud</a>
          if you need to get in touch for any topic other than support. In case of issues related to privacy,
          use the email address
          <a href="mailto:privacy@ganttproject.cloud">privacy@ganttproject.cloud</a>.
        </p>
        <p><b>Registered Office and Postal Address</b><br>
          Varšavská 715/36, Vinohrady, Praha 2, Praha 12000, Czechia
        </p>
      </div>
    </main>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
export default {
  name: "AboutContacts",
  components: {Header}
}
</script>

<style lang="scss">
@import 'sass/default';
</style>
